var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2281 18.1562L18.1561 29.2283C17.7778 29.6065 17.1504 29.6065 16.7721 29.2283C16.3938 28.85 16.3938 28.2225 16.7721 27.8443L27.8441 16.7722C28.2224 16.3939 28.8498 16.3939 29.2281 16.7722C29.6064 17.1505 29.6064 17.778 29.2281 18.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.2281 29.2278C28.8498 29.6061 28.2224 29.6061 27.8441 29.2278L16.7721 18.1557C16.3938 17.7775 16.3938 17.15 16.7721 16.7717C17.1504 16.3935 17.7778 16.3935 18.1561 16.7717L29.2281 27.8438C29.6064 28.222 29.6064 28.8495 29.2281 29.2278Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cbf9eff6e6ea7fe14c9cbb05b892950b.svg";
export { ForwardRef as ReactComponent };